import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { TextField, Button, Container, Typography } from "@mui/material";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    await axios.post(
      `https://app.metabolytics.ai/simulator-backend/healthcare/reset-password/${token}`,
      { newPassword }
    );
    alert("Password reset successful! You can now log in.");
    navigate("/login");
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Reset Password
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="New Password"
          type="password"
          variant="outlined"
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          sx={{ mt: 2 }}
        >
          Reset Password
        </Button>
      </form>
    </Container>
  );
}

export default ResetPassword;
